import controller from './bulk-edit-modal.controller';

const template = require('./bulk-edit-modal.html');

export default {
    controller,
    template
}; 